/* NIGHT OPERATORS mount add-on catalog (snippets/no-mount-cards.liquid). NEW FILE, t2-mounts-1019 lane.
   The theme's product-info-upsell element keeps doing the cart work for the main Add to cart button (data-selected,
   data-id). This file adds: the "See all N" opener, keyboard ticks, the price of the picked choice, the running
   summary, and an Add button in the summary. That button presses the main Add to cart (so the main product and every
   ticked mount go in one request); if the main product is already in the cart it adds only the ticked mounts.
   No em or en dashes. */
(function () {
  function money(root, cents) {
    var t = root.getAttribute('data-money') || '$1,234.56';
    var v = (cents / 100).toFixed(2).split('.');
    return t.replace(/[0-9][0-9.,]*[0-9]/, v[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',') + '.' + v[1]);
  }
  function variants(card) {
    if (card._nomcV) return card._nomcV;
    var s = card.querySelector('.nomc__pick script[type="application/json"]');
    card._nomcV = s ? JSON.parse(s.textContent) : [];
    var al = card.getAttribute('data-allow');
    if (al) card._nomcV = card._nomcV.filter(function (v) { return al.indexOf(',' + v.id + ',') > -1; });
    return card._nomcV;
  }
  function priceOf(card) {
    var id = String(card.dataset.id), vs = variants(card);
    for (var i = 0; i < vs.length; i++) if (String(vs[i].id) === id) return vs[i].price;
    var t = card.querySelector('[data-nomc-price]');
    return t ? Math.round(parseFloat(t.textContent.replace(/[^0-9.]/g, '')) * 100) : 0;
  }
  function inCart(handle) {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); })
      .then(function (c) { return (c.items || []).some(function (i) { return i.handle === handle; }); })
      .catch(function () { return false; });
  }
  function init(root) {
    if (root._nomc) return; root._nomc = true;
    var cards = [].slice.call(root.querySelectorAll('.nomc__card'));
    var list = root.querySelector('[data-nomc-list]');
    var more = root.querySelector('[data-nomc-more]');
    var main = root.getAttribute('data-main') || 'this item';
    var total = cards.length;
    var noun = (root.querySelector('.nomc__all') || {}).textContent || '';
    /* short list: no opener, no fade */
    function measure() {
      var cap = parseFloat(getComputedStyle(root).getPropertyValue('--nomc-cap')) || 470;
      root.classList.toggle('is-short', list.scrollHeight <= cap + 40);
    }
    measure(); window.addEventListener('resize', measure);
    if (more) more.addEventListener('click', function () {
      var open = !root.classList.contains('is-open');
      root.classList.toggle('is-open', open);
      more.setAttribute('aria-expanded', open ? 'true' : 'false');
      var l = more.querySelector('[data-nomc-morelabel]');
      if (l) l.textContent = open ? 'Show fewer' : ('See all ' + noun.trim());
      if (!open) root.scrollIntoView({ block: 'nearest' });
    });
    var sumBox = root.querySelector('[data-nomc-sumbox]'), sumT = root.querySelector('[data-nomc-sum]'), addB = root.querySelector('[data-nomc-add]');
    function picked() { return cards.filter(function (c) { return c.dataset.selected === 'true'; }); }
    function sum() {
      var on = picked(), cents = 0;
      cards.forEach(function (c) { var inn = c.querySelector('.nomc__in'); if (inn) inn.setAttribute('aria-checked', c.dataset.selected === 'true' ? 'true' : 'false'); });
      on.forEach(function (c) { cents += priceOf(c); });
      if (sumBox) sumBox.classList.toggle('is-on', on.length > 0);
      if (sumT) sumT.textContent = on.length ? (on.length + ' added, +' + money(root, cents) + ': ' + on.map(function (c) { var n = c.querySelector('.nomc__name'); return n ? n.textContent.trim() : ''; }).join(', ')) : 'Nothing added. Tick a row to add it.';
      if (addB) { addB.hidden = !on.length; addB.textContent = 'Add ' + main + ' + ' + on.length + (on.length === 1 ? ' item' : ' items'); }
    }
    if (addB) addB.addEventListener('click', function () {
      var on = picked(); if (!on.length) return;
      addB.disabled = true;
      inCart(root.getAttribute('data-handle')).then(function (already) {
        if (!already) {
          var btn = document.querySelector('product-form.main-product-form button[name="add"], form[action*="/cart/add"] button[name="add"]');
          addB.disabled = false;
          if (btn) btn.click();
          return;
        }
        var items = on.map(function (c) { return { id: Number(c.dataset.id), quantity: 1 }; });
        return fetch('/cart/add.js', { method: 'POST', credentials: 'same-origin', headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }, body: JSON.stringify({ items: items }) })
          .then(function (r) { if (!r.ok) throw new Error('add failed'); return r.json(); })
          .then(function (j) { addB.disabled = false; if (window.noCartDrawerOpen) { window.noCartDrawerOpen(j); return; } window.location.href = '/cart'; })
          .catch(function () { addB.disabled = false; if (sumT) sumT.textContent = 'Could not add. Please try again.'; });
      });
    });
    cards.forEach(function (c) {
      var inn = c.querySelector('.nomc__in');
      /* the picture, the name and View product open the product page; a tap on them never ticks the row (20 Oct) */
      [].forEach.call(c.querySelectorAll('[data-nomc-link]'), function (link) { link.addEventListener('click', function (e) { e.stopPropagation(); }); });
      if (inn) inn.addEventListener('keydown', function (e) {
        if ((e.key === 'Enter' || e.key === ' ') && e.target === inn) { e.preventDefault(); inn.click(); }
      });
      var pick = c.querySelector('.nomc__pick');
      if (pick) {
        pick.addEventListener('click', function (e) { e.stopPropagation(); });
        pick.addEventListener('change', function () {
          var sels = [].slice.call(pick.querySelectorAll('select'));
          var want = sels.map(function (s) { return s.value; });
          var vs = variants(c), hit = null;
          vs.forEach(function (v) { if (!hit && want.every(function (w, i) { return v.options[i] === w; })) hit = v; });
          if (!hit && sels.length > 1) {
            /* that pair does not exist (for example Tan at 1.42 in): keep the first choice, move the second to one that exists */
            vs.forEach(function (v) { if (!hit && v.available && v.options[0] === want[0]) hit = v; });
            if (hit) sels.forEach(function (s, i) { s.value = hit.options[i]; });
          }
          if (hit) {
            c.dataset.id = hit.id;
            var p = c.querySelector('[data-nomc-price]'); if (p) p.textContent = money(root, hit.price);
            var img = c.querySelector('.upsell__image__img');
            if (img && hit.featured_image && hit.featured_image.src) img.src = hit.featured_image.src.replace(/^https?:/, '') + (hit.featured_image.src.indexOf('?') > -1 ? '&' : '?') + 'width=200';
            [].forEach.call(c.querySelectorAll('[data-nomc-link][data-base]'), function (a) { a.setAttribute('href', a.getAttribute('data-base') + '?variant=' + hit.id); });
          }
          sum();
        });
      }
      new MutationObserver(sum).observe(c, { attributes: true, attributeFilter: ['data-selected', 'data-id'] });
    });
    sum();
  }
  function boot() { [].forEach.call(document.querySelectorAll('[data-nomc]'), init); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
